module.exports = __webpack_public_path__ + "img/entity2.ac077f08.png";